<template>
  <v-container class="d-flex flex-column pa-0 ml-3">
    <v-btn
      :to="{ name: 'pulpit.obecne' }"
      x-large
      :color="$route.name === 'pulpit.obecne' ? selectedColor : defaultColor"
      width="250"
      active-class="aa"
      exact
    >
      Obecne
      <v-chip
        class="ma-2"
        color="white"
        :text-color="$route.name === 'obecne' ? selectedColor : defaultColor"
        small
      >
        <strong>{{ menuCount.desktop.present }}</strong>
      </v-chip>
    </v-btn>

    <v-btn
      :to="{ name: 'pulpit.nieobecne' }"
      x-large
      :color="$route.name === 'pulpit.nieobecne' ? selectedColor : defaultColor"
      width="250"
      active-class="aa"
      exact
    >
      Nieobecne
      <v-chip
        class="ma-2"
        color="white"
        :text-color="$route.name === 'nieobecne' ? selectedColor : defaultColor"
        small
      >
        <strong>{{ menuCount.desktop.absent }}</strong>
      </v-chip>
    </v-btn>

    <v-btn
      v-if="user.permissions['desktop'] >= 10"
      :to="{ name: 'pulpit.bezstatusu' }"
      x-large
      :color="
        $route.name === 'pulpit.bezstatusu' ? selectedColor : defaultColor
      "
      width="250"
      active-class="aa"
      exact
    >
      Bez statusu
      <v-chip
        class="ma-2"
        color="white"
        :text-color="
          $route.name === 'bezstatusu' ? selectedColor : defaultColor
        "
        small
      >
        <strong>{{ menuCount.desktop.nostatus }}</strong>
      </v-chip>
    </v-btn>

    <v-btn
      :to="{ name: 'pulpit.nieodebrane' }"
      x-large
      :color="
        $route.name === 'pulpit.nieodebrane' ? selectedColor : defaultColor
      "
      width="250"
      active-class="aa"
      exact
    >
      Nieodebrane
      <v-chip
        class="ma-2"
        color="white"
        :text-color="
          $route.name === 'nieodebrane' ? selectedColor : defaultColor
        "
        small
      >
        <strong>{{ menuCount.desktop.late }}</strong>
      </v-chip>
    </v-btn>

    <v-dialog v-if="user.permissions['desktop'] >= 10" v-model="dialog" max-width="700px">
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          x-large
          class="mt-10"
          width="250"
          active-class="aa"
          :color="defaultColor"
          exact
        >
          Przyjęcie zgłoszenia
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Przyjęcie zgłoszenia nieobecności</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col class="col-8">
                <v-autocomplete
                  :error-messages="child_idErrors"
                  :readonly="editedItem.child_id !== undefined"
                  v-model="editedItem.child_id"
                  :loading="childrenLookupLoadStatus == 1"
                  :items="childrenLookup"
                  :search-input.sync="searchReference"
                  class="search"
                  style="max-width: 400px;"
                  flat
                  hide-no-data
                  label="Wyszukaj dziecko"
                  clearable
                ></v-autocomplete>
              </v-col>
              
              <v-col class="col-4">
                <v-select
                  item-value="text"
                  :error-messages="noteErrors"
                  required
                  @input="$v.editedItem.note.$touch()"
                  @blur="$v.editedItem.note.$touch()"
                  v-model="editedItem.note"
                  :items="lookups.reasons"
                  label="Powód nieobecności"
                ></v-select>
              </v-col>

              <v-col class="col-12">
                <v-text-field
                  item-value="text"
                  v-model="editedItem.noteText"
                  :items="lookups.reasons"
                  label="Dodatkowe informacje"
                ></v-text-field>
              </v-col>
              
               <v-col class="col-4">
                <v-menu
                  v-model="dateFromMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="150px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="editedItem.from"
                      :error-messages="fromErrors"
                      required
                      @input="$v.editedItem.from.$touch()"
                      @blur="$v.editedItem.from.$touch()"
                      label="Od"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-on="on"
                      class="choose_date mt-6 mr-5"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    first-day-of-week="1"
                    no-title
                    v-model="editedItem.from"
                    @input="dateFromMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="col-4">
                <v-menu
                  v-model="dateToMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="150px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                    :error-messages="toErrors"
                      required
                      @input="$v.editedItem.to.$touch()"
                      @blur="$v.editedItem.to.$touch()"
                      v-model="editedItem.to"
                      label="Do"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-on="on"
                      class="choose_date mt-6 mr-5"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    first-day-of-week="1"
                    no-title
                    v-model="editedItem.to"
                    @input="dateToMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              
            </v-row>
            <v-row v-if="getPresenceAddStatus===3">
                                    <v-col class="d-flex flex-column align-center">
                                        <v-alert v-for="err in errorMessageArray(getPresenceAddText)" :key="err.index" dense outlined type="error">
                                          {{err}}
                                        </v-alert>    
                                    </v-col>
                            </v-row>     
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="gray" text @click="close">Anuluj</v-btn>
          <v-btn color="primary darken-1" text @click="handleSubmit"
            >Zapisz</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-if="user.permissions['desktop'] >= 10 && nfcStatus=='OK'" v-model="dialogNFC" max-width="700px">
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          x-large
          class="mt-10"
          width="250"
          active-class="aa"
          :color="defaultColor"
          exact
        >
          Karty NFC
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Karty NFC</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            {{cardSerial}}
            <!-- <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-autocomplete
                  :error-messages="child_idErrors"
                  :readonly="editedItem.child_id !== undefined"
                  v-model="editedItem.child_id"
                  :loading="childrenLookupLoadStatus == 1"
                  :items="childrenLookup"
                  :search-input.sync="searchReference"
                  class="search"
                  style="max-width: 400px;"
                  flat
                  hide-no-data
                  label="Wyszukaj dziecko"
                  clearable
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="1" md="1"> </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-select
                  item-value="text"
                  :error-messages="noteErrors"
                  required
                  @input="$v.editedItem.note.$touch()"
                  @blur="$v.editedItem.note.$touch()"
                  v-model="editedItem.note"
                  :items="lookups.reasons"
                  label="Powód nieobecności"
                ></v-select>
              </v-col>

              <v-col cols="12" sm="4" md="4">
                <v-menu
                  v-model="dateFromMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="150px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="editedItem.from"
                      :error-messages="fromErrors"
                      required
                      @input="$v.editedItem.from.$touch()"
                      @blur="$v.editedItem.from.$touch()"
                      label="Od"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-on="on"
                      class="choose_date mt-6 mr-5"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    first-day-of-week="1"
                    no-title
                    v-model="editedItem.from"
                    @input="dateFromMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-menu
                  v-model="dateToMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="150px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                    :error-messages="toErrors"
                      required
                      @input="$v.editedItem.to.$touch()"
                      @blur="$v.editedItem.to.$touch()"
                      v-model="editedItem.to"
                      label="Do"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-on="on"
                      class="choose_date mt-6 mr-5"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    first-day-of-week="1"
                    no-title
                    v-model="editedItem.to"
                    @input="dateToMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row v-if="getPresenceAddStatus===3">
                                    <v-col class="d-flex flex-column align-center">
                                        <v-alert v-for="err in errorMessageArray(getPresenceAddText)" :key="err.index" dense outlined type="error">
                                          {{err}}
                                        </v-alert>    
                                    </v-col>
                            </v-row>      -->
          </v-container>
        </v-card-text>

        <v-card-actions>
          <!-- <v-spacer></v-spacer>
          <v-btn color="gray" text @click="close">Anuluj</v-btn>
          <v-btn color="primary darken-1" text @click="handleSubmit"
            >Zapisz</v-btn
          > -->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import required from "vuelidate/lib/validators/required";

export default {
  data() {
    return {
      defaultColor: "secondary",
      selectedColor: "primary",
      dialog: false,
      dialogNFC: false,
      interval:{},
      cardSerial:undefined,
      searchReference: null,
      dateFromMenu: false,
      dateToMenu: false,
      editedItem: {
        child_id: undefined,
        note: "",
        from: "",
        to: "",
      },
      editedItemDefault: {
        child_id: undefined,
        note: "",
        from: "",
        to: "",
      },
    };
  },
  mounted() {
    //pobierabie liczników
    this.$store.dispatch("loadMenuDesktopCount");
    //this.$store.dispatch( 'loadLookups' );
  },
  watch: {
    dialog(val) {
      this.$v.$reset();
      val || this.close();
    },
    dialogNFC(val) {
      if(val){
        this.interval = setInterval(() => {
            this.checkCard();
        }, 1000);
      }else{
        clearInterval(this.interval);
      }
    },
    searchReference(val) {
      val &&
        val !== this.editedItem.child_id &&
        !this.editedItem.child_id &&
        val.length > 2 &&
        this.querySelectionsReference(val);
    },
    getPresenceAddStatus(val){
        if(val===2){
          this.close();
        }
      },
  },
  validations: {
    editedItem: {
      child_id: {
        required,
      },
      note: {
        required,
      },
      from: {
        required,
      },
      to: {
        required,
      },
    },
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
    lookups() {
      return this.$store.getters.getLookups;
    },
    menuCount() {
      return this.$store.getters.getMenu;
    },
    from(){
      return this.editedItem.from;
    },
    child_idErrors() {
      const errors = [];
      if (!this.$v.editedItem.child_id.$dirty) return errors;
      !this.$v.editedItem.child_id.required &&
        errors.push("Dziecko jest wymagane");
      return errors;
    },
    noteErrors() {
      const errors = [];
      if (!this.$v.editedItem.note.$dirty) return errors;
      !this.$v.editedItem.note.required && errors.push("Powód jest wymagany");
      return errors;
    },
    fromErrors() {
      const errors = [];
      if (!this.$v.editedItem.from.$dirty) return errors;
      !this.$v.editedItem.from.required && errors.push("Data jest wymagana");
      return errors;
    },
    toErrors() {
      const errors = [];
      if (!this.$v.editedItem.to.$dirty) return errors;
      !this.$v.editedItem.to.required && errors.push("Data jest wymagana");
      return errors;
    },
    childrenLookupLoadStatus() {
      return this.$store.getters.getChildrenLookupLoadStatus;
    },
    childrenLookup() {
      return this.$store.getters.getChildrenLookup;
    },
    getPresenceAddStatus() {
      return this.$store.getters.getPresenceAddStatus;
    },
    getPresenceAddText(){
      return this.$store.getters.getPresenceAddText;
    },
    nfcStatus(){
        return this.$store.getters.getNfcStatus();
    }
  },
  methods: {
    async checkCard(){
      await uFR_Request("ReaderOpen");
      let output = await uFR_Request("GetCardId");
      await uFR_Request("ReaderClose");
      console.log(output);
      if(output.Status == '[0x00 (0)] UFR_OK'){
        this.cardSerial = output.CardSerial;
        
      }
      //this.cardSerial = (output.Status == '[0x00 (0)] UFR_OK');
    },
    close() {
      this.dialog = false;
      this.$v.$reset();
      this.editedItem = {...this.editedItemDefault};
      setTimeout(() => {
          this.$store.dispatch( 'loadPresenceAddDefault');
        }, 300)
    },
    querySelectionsReference(v) {
      this.$store.dispatch("searchChildrenLookup", { q: v, slug: 0 });
    },
    errorMessageArray(val) {
        const errors = val;
        var err = [];
        if(!errors)return [];

        if(errors.to){
          errors.to.forEach(e => {
            err.push(e);
          });
        }

        return err;
      },     
    handleSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
      } else {
        this.$store.dispatch( 'addChildAbsense', {
          child_id:  this.editedItem.child_id,
          note: this.editedItem.note,
          noteText: this.editedItem.noteText,
          from: this.editedItem.from,
          to: this.editedItem.to,
        });
      }
    },
  },
};
</script>

<style scoped>
.v-btn {
  margin-bottom: 1em;
}
.v-chip {
  margin-left: 1em;
}
.v-chip:hover {
  cursor: pointer;
}
.v-btn:not(.v-btn--text):not(.v-btn--outlined).v-btn--active:before {
  opacity: 0;
}
.search {
  max-width: 250px;
}
</style>
